import React from 'react';

import { Title } from 'Storybook/components/local/Title/Title';

import Breadcrumbs from '../../../../fastlane/breadcrumbs/Breadcrumbs';

import styles from '../../WordpressPages.scss';

type HeaderProps = {
  pageTitle?: string | null;
  topNav: {
    label: string;
    route: string;
  }[];
};

export const Header: React.FC<HeaderProps> = ({ pageTitle, topNav }) => {
  const list = topNav;
  return (
    <>
      <Breadcrumbs leftAlign className={styles.topNav} {...{ list }} />
      {pageTitle && (
        <Title large className={styles.mainTitle} element="h1">
          {pageTitle}
        </Title>
      )}
    </>
  );
};
